
import React, { useEffect, useCallback, useMemo, useState } from "react";
import HeaderComponent from '../../components/header';
import { Card, Button, Badge, Form, Tabs, Tab, Dropdown, Container, Col, Row } from 'react-bootstrap';
import Chart from 'react-apexcharts';

function ESGDashboard() {

    const pieOptions = {
        labels: ['Fundentes', 'Minério', 'Cales'],
        colors: ['#a855f7', '#BDD714', '#1e3a8a'],
        legend: {
            position: "right",
            fontSize: 14,
            offsetY: 0,
            clusterGroupedSeries: true,
            clusterGroupedSeriesOrientation: "vertical",
            markers: {
                size: 7
            },
            itemMargin: {
                vertical: 0
            },
            show: true
        }

    };

    const pieSeries = [40, 25, 35];

    const empresas = [
        {
            name: 'Mineração Polaris',
            value: '30',
            value2: '30',
            value3: '30'
        },
        {
            name: 'Calcinação Imperial',
            value: '30',
            value2: '10',
            value3: '30'
        },
        {
            name: 'Ical Industria de Cal',
            value: '30',
            value2: '15',
            value3: '25'
        },
        {
            name: 'Extrativa mineral s/A',
            value: '30',
            value2: '25',
            value3: '15'
        }
    ];

    const indicadores = [
        'Grupo Econômico',
        'Participação em empresas',
        'Empresas dos Sócios',
        'Gestão de Resíduos'
    ];

    const coresIndicadores = ['#22c55e', '#a3e635', '#6b7280', '#374151'];

    return (
        <>
            <HeaderComponent />
            <section className='panel-default'>
                <h5 className="mb-4">Dashboard Riscos ESG</h5>
                <Row style={{ height: 'calc(100vh - 255px)', overflow: 'auto' }}>

                    {/* Inicio */}
                    <Col md={8}>
                        <Row className="mb-2">
                            {/* Coluna 1 - Empresas */}
                            <Col>
                                <div className="mb-3 rect-content-base p-3">
                                    <div style={{ minHeight: '365px', overflow: 'auto' }}>
                                        {empresas.map((empresa, idx) => (
                                            <div key={idx} className="mb-4 d-flex">
                                                <div className="barchart-title">{empresa.name}</div>
                                                <div className="d-flex barchart-bar">
                                                    <div style={{ width: empresa.value + '%' }}></div>
                                                    <div style={{ width: empresa.value2 + '%' }}></div>
                                                    <div style={{ width: empresa.value3 + '%' }}></div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </Col>
                            {/* Coluna 2 - Gráfico e Filtros */}
                            <Col>
                                <div className="mb-3 rect-content-base p-3">
                                    <div style={{ minHeight: '365px', overflow: 'auto' }}>
                                        <div className="text-center">Categorias</div>
                                        <div className="margin--auto" style={{ width: '300px' }}>
                                            <Chart options={pieOptions} series={pieSeries} type="donut" width="300" height="250" />
                                        </div>
                                        <Form.Select size="sm" className="mt-3 mb-4">
                                            <option>Selecione</option>
                                            <option>Opção 1</option>
                                            <option>Opção 2</option>
                                            <option>Opção 3</option>
                                        </Form.Select>
                                        <div className="mt-2 d-flex" style={{ flexFlow: 'wrap' }}>
                                            <div class="tag tag--ghost" title="Opção 1">
                                                <a href="javascript:;">
                                                    <i class="me-2 bi bi-x-circle"></i>
                                                    {/* <i class="bi bi-check-circle"></i> */}
                                                </a>
                                                Opção 1
                                            </div>
                                            <div class="tag tag--ghost" title="Opção 2">
                                                <a href="javascript:;">
                                                    <i class="me-2 bi bi-x-circle"></i>
                                                    {/* <i class="bi bi-check-circle"></i> */}
                                                </a>
                                                Opção 2
                                            </div>
                                            <div class="tag tag--ghost" title="Opção 3">
                                                <a href="javascript:;">
                                                    <i class="me-2 bi bi-x-circle"></i>
                                                    {/* <i class="bi bi-check-circle"></i> */}
                                                </a>
                                                Opção 3
                                            </div>
                                        </div>
                                        <div className="mt-5 text-center">
                                            <Form.Check inline type="checkbox" label="Cales" />
                                            <Form.Check inline type="checkbox" label="Fundentes" />
                                            <Form.Check inline type="checkbox" label="Minério" />
                                        </div>
                                    </div>
                                </div>
                            </Col>

                        </Row>
                        {/* Filtros adicionais */}
                        <Row>
                            <Col>
                                <div className="mb-3 rect-content-base p-3">
                                    <Row style={{ minHeight: 'calc(100vh - 732px)', overflow: 'auto' }}>
                                        <Col md={3} >
                                            <Form.Select size="sm" className="mb-4">
                                                <option>Selecione</option>
                                                <option>Opção 1</option>
                                                <option>Opção 2</option>
                                                <option>Opção 3</option>
                                            </Form.Select>
                                            <div className="mt-2 d-flex" style={{ flexFlow: 'wrap' }}>
                                                <div class="tag tag--ghost" title="Opção 1">
                                                    <a href="javascript:;">
                                                        <i class="me-2 bi bi-x-circle"></i>
                                                        {/* <i class="bi bi-check-circle"></i> */}
                                                    </a>
                                                    Opção 1
                                                </div>
                                                <div class="tag tag--ghost" title="Opção 2">
                                                    <a href="javascript:;">
                                                        <i class="me-2 bi bi-x-circle"></i>
                                                        {/* <i class="bi bi-check-circle"></i> */}
                                                    </a>
                                                    Opção 2
                                                </div>
                                                <div class="tag tag--ghost" title="Opção 3">
                                                    <a href="javascript:;">
                                                        <i class="me-2 bi bi-x-circle"></i>
                                                        {/* <i class="bi bi-check-circle"></i> */}
                                                    </a>
                                                    Opção 3
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={9}>
                                            <Row className="mb-3">
                                                {[1, 2, 3, 4, 5, 6].map((_, idx) => (
                                                    <Col key={idx} md={2}>
                                                        <div className="filter-text">
                                                            Investigação Trabalho Degradante: <br /><strong className="text-primary">1</strong>
                                                        </div>
                                                        <Form.Select size="sm">
                                                            <option>Todos</option>
                                                            <option>Filtro 1</option>
                                                            <option>Filtro 2</option>
                                                        </Form.Select>
                                                    </Col>
                                                ))}
                                            </Row>
                                            <Row>
                                                {[1, 2, 3, 4, 5, 6].map((_, idx) => (
                                                    <Col key={idx} md={2}>
                                                        <div className="filter-text">
                                                            Investigação Trabalho Degradante: <br /><strong className="text-primary">1</strong>
                                                        </div>
                                                        <Form.Select size="sm">
                                                            <option>Todos</option>
                                                            <option>Filtro 1</option>
                                                            <option>Filtro 2</option>
                                                        </Form.Select>
                                                    </Col>
                                                ))}
                                            </Row>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </Col>

                    <Col md={4}>
                        <Row>
                            {/* Coluna 3 - Tabs e Cards */}
                            <Col>
                                <div className="mb-3 rect-content-base p-3">
                                    <div style={{ height: 'calc(100vh - 310px)', overflow: 'auto' }}>
                                        <div className="d-flex justify-content-between align-items-center mb-4">
                                            <div class="rect-tag small inmodal ambiental" style={{ fontWeight: '700', cursor: 'pointer' }}>Ambiental</div>
                                            <div class="rect-tag small inmodal social" style={{ fontWeight: '700', opacity: '0.5', cursor: 'pointer' }}>Social</div>
                                            <div class="rect-tag small inmodal governanca" style={{ fontWeight: '700', opacity: '0.5', cursor: 'pointer' }}>Governança</div>
                                        </div>
                                        <div>
                                            {indicadores.map((item, idx) => (
                                                <>
                                                    <Form.Check key={idx} type="switch" label={item} /><br />
                                                </>
                                            ))}
                                        </div>
                                        <div className="mt-5">
                                            {[1, 2, 3].map((_, idx) => (
                                                <div key={idx} class="rect-content-risks" style={{ width: '100%' }}>
                                                    <div class="rect-header">
                                                        <div class="rect-tag ambiental">Ambiental</div>
                                                    </div>
                                                    <div class="rect-tx-value">Peso: 4.5</div>
                                                    <p class="rect-tx-1" title="1- Licenciamento ambiental negado pelo órgão ambiental estadual de MG">1- Licenciamento ambiental negado pelo órgão ambiental estadual de MG</p>
                                                    <div class="rect-tx-2 truncate">
                                                        Possui 2 processos de licenciamento ambiental junto ao órgão ambiental estadual de Minas Gerais para regularização de atividades. Foi identificada decisão de arquivamento em 26/02/2021. A decisão mais recente em 26/02/2021 foi de arquivamento.
                                                    </div>
                                                    <div class="rect-link cursor-pointer">
                                                        <i class="bi bi-plus-circle-fill"></i>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>

                    {/* Fim */}
                </Row>
            </section>
        </>
    );
}

export default ESGDashboard;